// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Montserrat/static/Montserrat-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Montserrat/static/Montserrat-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../node_modules/slick-carousel/slick/ajax-loader.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../node_modules/slick-carousel/slick/fonts/slick.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../node_modules/slick-carousel/slick/fonts/slick.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../node_modules/slick-carousel/slick/fonts/slick.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../node_modules/slick-carousel/slick/fonts/slick.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___, { hash: "#slick" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
*,
html {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  overflow-x: hidden;
  color: #161a1d;
}

@font-face {
  font-family: "big";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "paragraph";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
h1 {
  font-size: 40px;
  margin: 24px 0px;
  font-family: "big";
}

h2,
h3 {
  font-size: 32px;
  margin: 24px 0px;
  font-family: "big";
}

h4,
p,
a,
button,
label,
input {
  font-size: 22px;
  font-family: "paragraph";
  line-height: 1.6em;
}

button {
  border: 4px solid #941b0c;
  padding: 16px 24px;
  margin: 16px;
  background-color: white;
}
button:hover {
  cursor: pointer;
  background-color: #941b0c;
  color: white;
}

.thick-arrow {
  position: relative;
  width: 200px;
  height: 200px;
}
.thick-arrow .main-arrow {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-left: 40px solid transparent;
  border-right: 40px solid transparent;
  border-bottom: 80px solid #f6aa1c;
  transform: translate(-50%, -46%);
  z-index: 2;
}
.thick-arrow .stroke-arrow {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-left: 52px solid transparent;
  border-right: 52px solid transparent;
  border-bottom: 104px solid #161a1d;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.down-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.down-btn p {
  background-color: white;
  border-radius: 40px;
  padding: 16px;
}
.down-btn .arrow {
  position: relative;
  height: 80px;
  width: 80px;
}
.down-btn .arrow .straight,
.down-btn .arrow .left,
.down-btn .arrow .right {
  position: absolute;
  display: inline-block;
  height: 4px;
  background-color: white;
}
.down-btn .arrow .straight {
  transform: rotate(90deg);
  top: 35px;
  left: 20px;
  width: 40px;
}
.down-btn .arrow .left {
  transform: rotate(45deg);
  top: 48px;
  left: 20px;
  width: 24px;
}
.down-btn .arrow .right {
  transform: rotate(-45deg);
  top: 48px;
  right: 20px;
  width: 24px;
}
.down-btn:hover {
  cursor: pointer;
  font-weight: bold;
}

/* Slider */
.slick-slider {
  position: relative;
  display: block;
  box-sizing: border-box;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
}

.slick-list {
  position: relative;
  overflow: hidden;
  display: block;
  margin: 0;
  padding: 0;
}
.slick-list:focus {
  outline: none;
}
.slick-list.dragging {
  cursor: pointer;
  cursor: hand;
}

.slick-slider .slick-track,
.slick-slider .slick-list {
  transform: translate3d(0, 0, 0);
}

.slick-track {
  position: relative;
  left: 0;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.slick-track:before, .slick-track:after {
  content: "";
  display: table;
}
.slick-track:after {
  clear: both;
}
.slick-loading .slick-track {
  visibility: hidden;
}

.slick-slide {
  float: left;
  height: 100%;
  min-height: 1px;
  display: none;
}
[dir=rtl] .slick-slide {
  float: right;
}
.slick-slide img {
  display: block;
}
.slick-slide.slick-loading img {
  display: none;
}
.slick-slide.dragging img {
  pointer-events: none;
}
.slick-initialized .slick-slide {
  display: block;
}
.slick-loading .slick-slide {
  visibility: hidden;
}
.slick-vertical .slick-slide {
  display: block;
  height: auto;
  border: 1px solid transparent;
}

.slick-arrow.slick-hidden {
  display: none;
}

/* Slider */
.slick-loading .slick-list {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center center no-repeat;
}

/* Icons */
@font-face {
  font-family: "slick";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
/* Arrows */
.slick-prev,
.slick-next {
  position: absolute;
  display: block;
  height: 20px;
  width: 20px;
  line-height: 0px;
  font-size: 0px;
  cursor: pointer;
  background: transparent;
  color: transparent;
  top: 50%;
  transform: translate(0, -50%);
  padding: 0;
  border: none;
  outline: none;
}
.slick-prev:hover, .slick-prev:focus,
.slick-next:hover,
.slick-next:focus {
  outline: none;
  background: transparent;
  color: transparent;
}
.slick-prev:hover:before, .slick-prev:focus:before,
.slick-next:hover:before,
.slick-next:focus:before {
  opacity: 1;
}
.slick-prev.slick-disabled:before,
.slick-next.slick-disabled:before {
  opacity: 0.25;
}
.slick-prev:before,
.slick-next:before {
  font-family: "slick";
  font-size: 20px;
  line-height: 1;
  color: white;
  opacity: 0.75;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.slick-prev {
  left: -25px;
}
[dir=rtl] .slick-prev {
  left: auto;
  right: -25px;
}
.slick-prev:before {
  content: "←";
}
[dir=rtl] .slick-prev:before {
  content: "→";
}

.slick-next {
  right: -25px;
}
[dir=rtl] .slick-next {
  left: -25px;
  right: auto;
}
.slick-next:before {
  content: "→";
}
[dir=rtl] .slick-next:before {
  content: "←";
}

/* Dots */
.slick-dotted.slick-slider {
  margin-bottom: 30px;
}

.slick-dots {
  position: absolute;
  bottom: -25px;
  list-style: none;
  display: block;
  text-align: center;
  padding: 0;
  margin: 0;
  width: 100%;
}
.slick-dots li {
  position: relative;
  display: inline-block;
  height: 20px;
  width: 20px;
  margin: 0 5px;
  padding: 0;
  cursor: pointer;
}
.slick-dots li button {
  border: 0;
  background: transparent;
  display: block;
  height: 20px;
  width: 20px;
  outline: none;
  line-height: 0px;
  font-size: 0px;
  color: transparent;
  padding: 5px;
  cursor: pointer;
}
.slick-dots li button:hover, .slick-dots li button:focus {
  outline: none;
}
.slick-dots li button:hover:before, .slick-dots li button:focus:before {
  opacity: 1;
}
.slick-dots li button:before {
  position: absolute;
  top: 0;
  left: 0;
  content: "•";
  width: 20px;
  height: 20px;
  font-family: "slick";
  font-size: 6px;
  line-height: 20px;
  text-align: center;
  color: black;
  opacity: 0.25;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.slick-dots li.slick-active button:before {
  color: black;
  opacity: 0.75;
}

.current-mission .about-us {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 0px;
  background-color: #f5f3f4;
}
.current-mission .about-us .content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80vw;
  margin: 40px;
  padding: 16px 32px;
  background-color: white;
  box-shadow: -16px 16px #941b0c;
}
.current-mission .take-action-container {
  background-color: #941b0c;
  display: flex;
  align-items: center;
  justify-content: center;
}
.current-mission .take-action-container .content {
  background-color: white;
  box-shadow: 16px 16px #161a1d;
  width: 80%;
  padding: 16px;
  margin: 40px 16px;
}
.current-mission .take-action-container .content h1 {
  text-align: center;
}
.current-mission .take-action-container .content ul li {
  width: -moz-fit-content;
  width: fit-content;
  box-shadow: -4px 4px #f5f3f4;
  margin: 24px 16px;
  padding: 8px;
  font-weight: bold;
}
.current-mission .gallery {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: #f5f3f4;
  padding: 40px 0px;
}
.current-mission .gallery .img-container {
  width: 80%;
}
.current-mission .gallery .img-container img {
  width: 100%;
  object-fit: contain;
}
.current-mission .localgov {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.current-mission .localgov .list {
  display: flex;
  justify-content: center;
  align-items: center;
}
.current-mission .localgov .list .card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 400px;
  text-align: center;
  margin: 80px;
  background-color: #f5f3f4;
  box-shadow: 16px 16px #941b0c;
}
.current-mission .localgov .list .card img {
  width: 100%;
  object-fit: cover;
}
.current-mission .localgov .list .card p {
  font-weight: bold;
  padding: 24px 0px;
}

@keyframes moveRight {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}
@media screen and (max-width: 980px) {
  .current-mission .localgov .list {
    flex-direction: column;
  }
  .current-mission .localgov .list .card {
    width: 80%;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/currentmission.scss","webpack://./src/styles/main.scss","webpack://./node_modules/slick-carousel/slick/slick.scss","webpack://./node_modules/slick-carousel/slick/slick-theme.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACUhB;;EAEE,UAAA;EACA,SAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAfW;ADOb;;ACWA;EACE,kBAAA;EACA,4CAAA;ADRF;ACWA;EACE,wBAAA;EACA,4CAAA;ADTF;ACYA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;ADVF;;ACaA;;EAEE,eAAA;EACA,gBAAA;EACA,kBAAA;ADVF;;ACaA;;;;;;EAME,eAAA;EACA,wBAAA;EACA,kBAAA;ADVF;;ACaA;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAzDY;AD+Cd;ACYE;EACE,eAAA;EACA,yBA3DY;EA4DZ,YA9DU;ADoDd;;ACcA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;ADXF;ACaE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;EACA,gCAAA;EACA,UAAA;ADXJ;ACcE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,kCAAA;EACA,gCAAA;EACA,UAAA;ADZJ;;ACgBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;ADbF;ACeE;EACE,uBAAA;EACA,mBAnGK;EAoGL,aAAA;ADbJ;ACgBE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;ADdJ;ACgBI;;;EAGE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,uBAAA;ADdN;ACiBI;EACE,wBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;ADfN;ACkBI;EACE,wBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;ADhBN;ACmBI;EACE,yBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;ADjBN;ACqBE;EACE,eAAA;EACA,iBAAA;ADnBJ;;AElIA,WAAA;AAEA;EACI,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,2BAAA;EACA,yBAAA;EAIA,iBAAA;EAEA,mBAAA;EACA,wCAAA;AFoIJ;;AElIA;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;AFqIJ;AEnII;EACI,aAAA;AFqIR;AElII;EACI,eAAA;EACA,YAAA;AFoIR;;AEjIA;;EAMI,+BAAA;AFoIJ;;AEjIA;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AFoIJ;AElII;EAEI,WAAA;EACA,cAAA;AFmIR;AEhII;EACI,WAAA;AFkIR;AE/HI;EACI,kBAAA;AFiIR;;AE9HA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EAWA,aAAA;AFuHJ;AEjII;EACI,YAAA;AFmIR;AEjII;EACI,cAAA;AFmIR;AEjII;EACI,aAAA;AFmIR;AE9HI;EACI,oBAAA;AFgIR;AE7HI;EACI,cAAA;AF+HR;AE5HI;EACI,kBAAA;AF8HR;AE3HI;EACI,cAAA;EACA,YAAA;EACA,6BAAA;AF6HR;;AE1HA;EACI,aAAA;AF6HJ;;AGtLA,WAAA;AAGI;EACI,gFAAA;AHuLR;;AGnLA,UAAA;AAEI;EACI,oBAAA;EACA,4CAAA;EACA,mPAAA;EACA,mBAAA;EACA,kBAAA;AHqLR;AGjLA,WAAA;AAEA;;EAEI,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EAGA,6BAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;AHkLJ;AGjLI;;;EACI,aAAA;EACA,uBAAA;EACA,kBAAA;AHqLR;AGpLQ;;;EACI,UAjEa;AHyPzB;AGrLI;;EACI,aApEmB;AH4P3B;AGtLI;;EACI,oBAlFY;EAmFZ,eAAA;EACA,cAAA;EACA,YAnFY;EAoFZ,aA7EgB;EA8EhB,mCAAA;EACA,kCAAA;AHyLR;;AGrLA;EACI,WAAA;AHwLJ;AGvLI;EACI,UAAA;EACA,YAAA;AHyLR;AGvLI;EACI,YA9Fe;AHuRvB;AGxLQ;EACI,YA/FW;AHyRvB;;AGrLA;EACI,YAAA;AHwLJ;AGvLI;EACI,WAAA;EACA,WAAA;AHyLR;AGvLI;EACI,YA3Ge;AHoSvB;AGxLQ;EACI,YA9GW;AHwSvB;;AGrLA,SAAA;AAEA;EACI,mBAAA;AHuLJ;;AGpLA;EACI,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AHuLJ;AGtLI;EACI,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;AHwLR;AGvLQ;EACI,SAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AHyLZ;AGxLY;EACI,aAAA;AH0LhB;AGzLgB;EACI,UApJK;AH+UzB;AGxLY;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YA9JM;EA+JN,WAAA;EACA,YAAA;EACA,oBAxKI;EAyKJ,cAjKC;EAkKD,iBAAA;EACA,kBAAA;EACA,YAzKE;EA0KF,aAlKW;EAmKX,mCAAA;EACA,kCAAA;AH0LhB;AGvLQ;EACI,YAhLM;EAiLN,aA3KY;AHoWxB;;AAlXE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,yBCPU;AD4Xd;AAnXI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBCrBQ;EDsBR,8BAAA;AAqXN;AAlXE;EACE,yBCxBY;EDyBZ,aAAA;EACA,mBAAA;EACA,uBAAA;AAoXJ;AAlXI;EACE,uBChCQ;EDiCR,6BAAA;EACA,UAAA;EACA,aAAA;EACA,iBAAA;AAoXN;AAlXM;EACE,kBAAA;AAoXR;AAhXQ;EACE,uBAAA;EAAA,kBAAA;EACA,4BAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;AAkXV;AA7WE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBCvDU;EDwDV,iBAAA;AA+WJ;AA7WI;EACE,UAAA;AA+WN;AA7WM;EACE,WAAA;EACA,mBAAA;AA+WR;AA3WE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AA6WJ;AA3WI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AA6WN;AA3WM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,yBCtFM;EDuFN,6BAAA;AA6WR;AA3WQ;EACE,WAAA;EACA,iBAAA;AA6WV;AA1WQ;EACE,iBAAA;EACA,iBAAA;AA4WV;;AArWA;EACE;IACE,yBAAA;EAwWF;EAtWA;IACE,2BAAA;EAwWF;AACF;AApWA;EAGM;IACE,sBAAA;EAoWN;EAlWM;IACE,UAAA;EAoWR;AACF","sourcesContent":["@import \"./main.scss\";\n@import \"~slick-carousel/slick/slick.scss\";\n@import \"~slick-carousel/slick/slick-theme.scss\";\n\n.current-mission {\n  .about-us {\n    text-align: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 80px 0px;\n    background-color: $third-color;\n\n    .content {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      width: 80vw;\n      margin: 40px;\n      padding: 16px 32px;\n      background-color: $light-color;\n      box-shadow: -16px 16px $primary-color;\n    }\n  }\n  .take-action-container {\n    background-color: $primary-color;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .content {\n      background-color: $light-color;\n      box-shadow: 16px 16px $dark-color;\n      width: 80%;\n      padding: 16px;\n      margin: 40px 16px;\n\n      h1 {\n        text-align: center;\n      }\n\n      ul{\n        li{\n          width: fit-content;\n          box-shadow: -4px 4px $third-color;\n          margin: 24px 16px;\n          padding: 8px;\n          font-weight: bold;\n        }\n      }\n    }\n  }\n  .gallery {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    background-color: $third-color;\n    padding: 40px 0px;\n\n    .img-container {\n      width: 80%;\n\n      img {\n        width: 100%;\n        object-fit: contain;\n      }\n    }\n  }\n  .localgov {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    .list {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      .card {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        width: 400px;\n        text-align: center;\n        margin: 80px;\n        background-color: $third-color;\n        box-shadow: 16px 16px $primary-color;\n\n        img {\n          width: 100%;\n          object-fit: cover;\n        }\n\n        p {\n          font-weight: bold;\n          padding: 24px 0px;\n        }\n      }\n    }\n  }\n}\n\n@keyframes moveRight {\n  0% {\n    transform: translateX(0%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n\n@media screen and (max-width: $mobile-width) {\n  .current-mission{\n    .localgov{\n      .list{\n        flex-direction: column;\n\n        .card{\n          width: 80%;\n        }\n      }\n    }\n  }\n}","$light-color: white;\n$dark-color: #161a1d;\n$primary-color: #941b0c;\n$secondary-color: #f6aa1c;\n$third-color: #f5f3f4;\n\n$mobile-width: 980px;\n\n$radius: 40px;\n\n*,\nhtml {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  color: $dark-color;\n}\n\n@font-face {\n  font-family: \"big\";\n  src: url(\"../assets/fonts/Montserrat/static/Montserrat-Black.ttf\");\n}\n\n@font-face {\n  font-family: \"paragraph\";\n  src: url(\"../assets/fonts/Montserrat/static/Montserrat-Regular.ttf\");\n}\n\nh1 {\n  font-size: 40px;\n  margin: 24px 0px;\n  font-family: \"big\";\n}\n\nh2,\nh3 {\n  font-size: 32px;\n  margin: 24px 0px;\n  font-family: \"big\";\n}\n\nh4,\np,\na,\nbutton,\nlabel,\ninput {\n  font-size: 22px;\n  font-family: \"paragraph\";\n  line-height: 1.6em;\n}\n\nbutton {\n  border: 4px solid $primary-color;\n  padding: 16px 24px;\n  margin: 16px;\n  background-color: $light-color;\n\n  &:hover {\n    cursor: pointer;\n    background-color: $primary-color;\n    color: $light-color;\n  }\n}\n\n.thick-arrow {\n  position: relative;\n  width: 200px;\n  height: 200px;\n\n  .main-arrow {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 0;\n    height: 0;\n    border-left: 40px solid transparent;\n    border-right: 40px solid transparent;\n    border-bottom: 80px solid $secondary-color;\n    transform: translate(-50%, -46%);\n    z-index: 2;\n  }\n\n  .stroke-arrow {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 0;\n    height: 0;\n    border-left: 52px solid transparent;\n    border-right: 52px solid transparent;\n    border-bottom: 104px solid $dark-color;\n    transform: translate(-50%, -50%);\n    z-index: 1;\n  }\n}\n\n.down-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n\n  p {\n    background-color: white;\n    border-radius: $radius;\n    padding: 16px;\n  }\n\n  .arrow {\n    position: relative;\n    height: 80px;\n    width: 80px;\n\n    .straight,\n    .left,\n    .right {\n      position: absolute;\n      display: inline-block;\n      height: 4px;\n      background-color: white;\n    }\n\n    .straight {\n      transform: rotate(90deg);\n      top: 35px;\n      left: 20px;\n      width: 40px;\n    }\n\n    .left {\n      transform: rotate(45deg);\n      top: 48px;\n      left: 20px;\n      width: 24px;\n    }\n\n    .right {\n      transform: rotate(-45deg);\n      top: 48px;\n      right: 20px;\n      width: 24px;\n    }\n  }\n\n  &:hover {\n    cursor: pointer;\n    font-weight: bold;\n  }\n}\n","/* Slider */\n\n.slick-slider {\n    position: relative;\n    display: block;\n    box-sizing: border-box;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -ms-touch-action: pan-y;\n    touch-action: pan-y;\n    -webkit-tap-highlight-color: transparent;\n}\n.slick-list {\n    position: relative;\n    overflow: hidden;\n    display: block;\n    margin: 0;\n    padding: 0;\n\n    &:focus {\n        outline: none;\n    }\n\n    &.dragging {\n        cursor: pointer;\n        cursor: hand;\n    }\n}\n.slick-slider .slick-track,\n.slick-slider .slick-list {\n    -webkit-transform: translate3d(0, 0, 0);\n    -moz-transform: translate3d(0, 0, 0);\n    -ms-transform: translate3d(0, 0, 0);\n    -o-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n}\n\n.slick-track {\n    position: relative;\n    left: 0;\n    top: 0;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n\n    &:before,\n    &:after {\n        content: \"\";\n        display: table;\n    }\n\n    &:after {\n        clear: both;\n    }\n\n    .slick-loading & {\n        visibility: hidden;\n    }\n}\n.slick-slide {\n    float: left;\n    height: 100%;\n    min-height: 1px;\n    [dir=\"rtl\"] & {\n        float: right;\n    }\n    img {\n        display: block;\n    }\n    &.slick-loading img {\n        display: none;\n    }\n\n    display: none;\n\n    &.dragging img {\n        pointer-events: none;\n    }\n\n    .slick-initialized & {\n        display: block;\n    }\n\n    .slick-loading & {\n        visibility: hidden;\n    }\n\n    .slick-vertical & {\n        display: block;\n        height: auto;\n        border: 1px solid transparent;\n    }\n}\n.slick-arrow.slick-hidden {\n    display: none;\n}\n","@charset \"UTF-8\";\n\n// Default Variables\n\n// Slick icon entity codes outputs the following\n// \"\\2190\" outputs ascii character \"←\"\n// \"\\2192\" outputs ascii character \"→\"\n// \"\\2022\" outputs ascii character \"•\"\n\n$slick-font-path: \"./fonts/\" !default;\n$slick-font-family: \"slick\" !default;\n$slick-loader-path: \"./\" !default;\n$slick-arrow-color: white !default;\n$slick-dot-color: black !default;\n$slick-dot-color-active: $slick-dot-color !default;\n$slick-prev-character: \"\\2190\" !default;\n$slick-next-character: \"\\2192\" !default;\n$slick-dot-character: \"\\2022\" !default;\n$slick-dot-size: 6px !default;\n$slick-opacity-default: 0.75 !default;\n$slick-opacity-on-hover: 1 !default;\n$slick-opacity-not-active: 0.25 !default;\n\n@function slick-image-url($url) {\n    @if function-exists(image-url) {\n        @return image-url($url);\n    }\n    @else {\n        @return url($slick-loader-path + $url);\n    }\n}\n\n@function slick-font-url($url) {\n    @if function-exists(font-url) {\n        @return font-url($url);\n    }\n    @else {\n        @return url($slick-font-path + $url);\n    }\n}\n\n/* Slider */\n\n.slick-list {\n    .slick-loading & {\n        background: #fff slick-image-url(\"ajax-loader.gif\") center center no-repeat;\n    }\n}\n\n/* Icons */\n@if $slick-font-family == \"slick\" {\n    @font-face {\n        font-family: \"slick\";\n        src: slick-font-url(\"slick.eot\");\n        src: slick-font-url(\"slick.eot?#iefix\") format(\"embedded-opentype\"), slick-font-url(\"slick.woff\") format(\"woff\"), slick-font-url(\"slick.ttf\") format(\"truetype\"), slick-font-url(\"slick.svg#slick\") format(\"svg\");\n        font-weight: normal;\n        font-style: normal;\n    }\n}\n\n/* Arrows */\n\n.slick-prev,\n.slick-next {\n    position: absolute;\n    display: block;\n    height: 20px;\n    width: 20px;\n    line-height: 0px;\n    font-size: 0px;\n    cursor: pointer;\n    background: transparent;\n    color: transparent;\n    top: 50%;\n    -webkit-transform: translate(0, -50%);\n    -ms-transform: translate(0, -50%);\n    transform: translate(0, -50%);\n    padding: 0;\n    border: none;\n    outline: none;\n    &:hover, &:focus {\n        outline: none;\n        background: transparent;\n        color: transparent;\n        &:before {\n            opacity: $slick-opacity-on-hover;\n        }\n    }\n    &.slick-disabled:before {\n        opacity: $slick-opacity-not-active;\n    }\n    &:before {\n        font-family: $slick-font-family;\n        font-size: 20px;\n        line-height: 1;\n        color: $slick-arrow-color;\n        opacity: $slick-opacity-default;\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n    }\n}\n\n.slick-prev {\n    left: -25px;\n    [dir=\"rtl\"] & {\n        left: auto;\n        right: -25px;\n    }\n    &:before {\n        content: $slick-prev-character;\n        [dir=\"rtl\"] & {\n            content: $slick-next-character;\n        }\n    }\n}\n\n.slick-next {\n    right: -25px;\n    [dir=\"rtl\"] & {\n        left: -25px;\n        right: auto;\n    }\n    &:before {\n        content: $slick-next-character;\n        [dir=\"rtl\"] & {\n            content: $slick-prev-character;\n        }\n    }\n}\n\n/* Dots */\n\n.slick-dotted.slick-slider {\n    margin-bottom: 30px;\n}\n\n.slick-dots {\n    position: absolute;\n    bottom: -25px;\n    list-style: none;\n    display: block;\n    text-align: center;\n    padding: 0;\n    margin: 0;\n    width: 100%;\n    li {\n        position: relative;\n        display: inline-block;\n        height: 20px;\n        width: 20px;\n        margin: 0 5px;\n        padding: 0;\n        cursor: pointer;\n        button {\n            border: 0;\n            background: transparent;\n            display: block;\n            height: 20px;\n            width: 20px;\n            outline: none;\n            line-height: 0px;\n            font-size: 0px;\n            color: transparent;\n            padding: 5px;\n            cursor: pointer;\n            &:hover, &:focus {\n                outline: none;\n                &:before {\n                    opacity: $slick-opacity-on-hover;\n                }\n            }\n            &:before {\n                position: absolute;\n                top: 0;\n                left: 0;\n                content: $slick-dot-character;\n                width: 20px;\n                height: 20px;\n                font-family: $slick-font-family;\n                font-size: $slick-dot-size;\n                line-height: 20px;\n                text-align: center;\n                color: $slick-dot-color;\n                opacity: $slick-opacity-not-active;\n                -webkit-font-smoothing: antialiased;\n                -moz-osx-font-smoothing: grayscale;\n            }\n        }\n        &.slick-active button:before {\n            color: $slick-dot-color-active;\n            opacity: $slick-opacity-default;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
